import React from 'react';
import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const FinancePieChart = ({financePieChartData = {} }) => {
    const colors = ["#416EFC", "#953B8B", "#FFC34F", "#FF565B", "#d41212"];

const pieChartData = [
    {name: "Student", value: financePieChartData?.totalStudent || 0.7},
    {name: "Graduate", value: financePieChartData?.totalGraduate || 0.7},
    {name: "NYSC", value: financePieChartData?.totalNYSC || 0.7},
    {name: "Fellow", value: financePieChartData?.totalFellow || 0.7},
    {name: "Associate", value: financePieChartData?.totalAssociate || 0.7},

]

const sumTotal = pieChartData.reduce((acc, data) => acc + (data.value > 0.7 ? data.value : 0), 0);
const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.7;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        const value = pieChartData[index].value > 0.7 ? pieChartData[index].value : 0;


        return (
            <text
            x={x}
            y={y}
            fill="white"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={12}
            fontWeight="bold"
        >
            {value}
        </text>
        );
    };

    return (
        <Box bg={'#FFFFFF'} borderRadius={'20px'} p={5} h={['100%', '100%', '100%', '695px', '695px']}
            sx={{
                overflowY: "scroll",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                "-ms-overflow-style": "none",
                "&::-webkit-scrollbar": {
                    display: "none",
                },
            }}
            overflowY={"auto"}
        >
            <Flex justifyContent={'space-between'} alignItems={'center'} >
                <Flex flexDirection={'column'}>
                    <Text color={'#4D4D4D'} letterSpacing={'-0.754px'} fontSize={'16px'} fontWeight={'500'}>
                    Total members Per Category
                    </Text>
                    <Text color={'#4D4D4D'} fontSize={'10px'} fontWeight={'400'} lineHeight={'13.62px'} letterSpacing={'-0.75px'}>{sumTotal} Total Members</Text>
                </Flex>
            </Flex>
            <Flex w="100%" flexDirection={'column'} >
                <ResponsiveContainer width="100%" height={300} >
                    <PieChart>
                        <Pie
                            data={pieChartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={45}
                            outerRadius={85}
                            fill="#8884d8"
                            paddingAngle={5}
                            dataKey="value"
                            labelLine={false}
                            label={renderCustomizedLabel}
                        >
                            {pieChartData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
                <Divider orientation='horizontal' border={`1px solid #C6C6C666`} />
                <Flex direction="column" justify="center" py={5} gap={2}>
                    {
                        pieChartData.map((item, index) => (
                            <Flex alignItems={'center'} justifyContent={'space-between'} key={index} gap={3} >
                                <Flex alignItems={'center'} gap={2}>
                                    <Box bg={colors[index % colors.length]} h={2} w={4} borderRadius="3px" ></Box>
                                    <Text fontSize="12px" color="#000000B2" fontWeight={'700'} fontFamily={'inter'}>
                                        {item.name}
                                    </Text>
                                </Flex>
                                <Text color={'#717171'} fontSize={'12px'} fontWeight={'500'} lineHeight={'12.61px'}> {item.value > 0.7 ? item.value : 0} Member(s)</Text>
                            </Flex>
                        ))
                    }
                </Flex>
            </Flex>
        </Box>
    )
}

export default FinancePieChart